import React, { useState } from "react";
import { Col } from "react-bootstrap";
import { useLoaderData } from "react-router-dom";

import PlacementTeam from "./components/PlacementTeam";
import { IUserPlacement } from "./types/placement";

import { ITeam } from "../../../../types/api";

const Placement = (): React.JSX.Element => {
    const {
        teamId,
        teams: loadedTeams,
        ratings: loadedRatings,
    } = useLoaderData() as {
        teamId: number;
        teams: ITeam[];
        ratings: IUserPlacement[];
    };

    const [ratings, setRatings] = useState<IUserPlacement[]>(loadedRatings);

    const teams = loadedTeams.filter(
        t => t.id !== teamId && t.settings?.hideResumeFromPlacement !== true,
    );

    return (
        <div data-testid="placementContent">
            <p>
                Please place each team into 1 of 4 levels, represented by the
                stars, with 4 stars being the <b>highest level</b>. This page
                autosaves each selection you make and you can change a teams
                placement simply be clicking on a different star. Once the time
                period to place teams has ended, your selections at that time
                will automatically be submitted and be used for tabulation
                purposes.
            </p>
            <div id="teamSelect" data-testid="teamSelect">
                {teams
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map(t => (
                        <a href={`#team${t.id}`} key={`${t.id}-link`}>
                            {t.name}
                        </a>
                    ))}
            </div>
            {teams.map(t => {
                return (
                    <React.Fragment key={`${t.id}-resume`}>
                        <PlacementTeam
                            team={t}
                            ratings={ratings}
                            setRatings={setRatings}
                        />
                        <a href="#teamSelect">back to top</a>
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default Placement;
